import { useEffect, useState } from "react";
import { Card, CardBody } from "../../components/Card";
import { api } from "../../lib/api";

interface PaidPlanRequestRow {
  requestId: string;
  tenantId: string;
  contactEmail: string;
  expectedMonthlyVolume: number | null;
  useCase: string;
  status: string;
  createdAt: string;
}

export default function AdminPaidPlanRequests() {
  const [items, setItems] = useState<PaidPlanRequestRow[] | null>(null);

  useEffect(() => {
    api
      .get<PaidPlanRequestRow[]>("/api/admin/paid-plan-requests")
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Paid plan requests</h1>
        <p className="mt-1 text-sm text-gray-500">Tenants who've asked to convert from trial to paid.</p>
      </div>

      {items === null ? (
        <div className="text-sm text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <Card>
          <CardBody>
            <p className="px-6 py-12 text-center text-sm text-gray-500">No requests yet.</p>
          </CardBody>
        </Card>
      ) : (
        <Card>
          <ul className="divide-y divide-gray-100">
            {items.map((r) => (
              <li key={r.requestId} className="p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <a href={`/admin/tenants/${r.tenantId}`} className="text-sm font-semibold text-gray-900 hover:underline">
                        {r.tenantId}
                      </a>
                      <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
                        {r.status}
                      </span>
                    </div>
                    <p className="mt-0.5 text-sm text-gray-500">{r.contactEmail}</p>
                    {r.expectedMonthlyVolume != null && (
                      <p className="mt-1 text-sm text-gray-700">
                        Expected volume: <strong>{r.expectedMonthlyVolume.toLocaleString()}</strong> emails/month
                      </p>
                    )}
                    {r.useCase && <p className="mt-2 text-sm text-gray-600">{r.useCase}</p>}
                    <p className="mt-2 text-xs text-gray-400">
                      Submitted {new Date(r.createdAt).toLocaleString()}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
